package com.essntl.features.task.domain.use_case

import com.essntl.core.utils.viewmodel.Operation
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.features.task.domain.repository.TaskRepository
import com.essntl.toastmanager.ToastManager
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import org.koin.core.annotation.Single

@Single
class DeleteTaskUseCase(
    private val taskRepository: TaskRepository,
    private val toastManager: ToastManager,
) {
    data class UseCaseState(
        val loadingSet: Set<String> = emptySet(),
    )

    private val _state = MutableStateFlow(UseCaseState())
    val state = _state.asStateFlow()

    private val _successEvent = MutableSharedFlow<Operation.Delete<TaskModel>>()
    val successEvent = _successEvent.asSharedFlow()

    private val _failureEvent = MutableSharedFlow<Throwable>()
    val failureEvent = _failureEvent.asSharedFlow()

    suspend fun delete(
        task: TaskModel,
    ) {
        try {
            if (task.id in _state.value.loadingSet) return

            _state.update {
                it.copy(
                    loadingSet = _state.value.loadingSet + task.id,
                )
            }

            taskRepository.delete(task.id)
                .onSuccess {
                    _state.update {
                        it.copy(
                            loadingSet = _state.value.loadingSet - task.id,
                        )
                    }

                    _successEvent.emit(Operation.Delete(task))

                    toastManager.success(description = "Task deleted successfully")
                }
                .onFailure { e ->
                    _state.update {
                        it.copy(
                            loadingSet = _state.value.loadingSet - task.id,
                        )
                    }

                    _failureEvent.emit(e)
                }
        } catch (e: CancellationException) {
            _state.update {
                it.copy(
                    loadingSet = _state.value.loadingSet - task.id,
                )
            }

            _failureEvent.emit(e)
        }
    }

}